import { Avatar } from '@mui/material';

type PlayerAvatarProps = {
  name: string;
  bgColor?: string;
};

function stringToColor(string: string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

function stringAvatar(name: string, bgColor?: string) {
  const parts = name.split(' ');
  return {
    sx: {
      bgcolor: bgColor || stringToColor(name),
    },
    children: parts.length > 1 ? `${parts[0][0]}${parts[1][0]}` : parts[0][0],
  };
}

export const PlayerAvatar = ({ name, bgColor }: PlayerAvatarProps) => {
  return <Avatar {...stringAvatar(name, bgColor)} alt={name} />;
};
